module.exports = __webpack_public_path__ + "img/pen_edit_white.8d6cd98b.svg";